import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const DoneIcon = (props: IconProps) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M10 20.777a8.942 8.942 0 0 1 -2.48 -.969' />
    <path d='M14 3.223a9.003 9.003 0 0 1 0 17.554' />
    <path d='M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592' />
    <path d='M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305' />
    <path d='M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356' />
    <path d='M9 12l2 2l4 -4' />
  </Icon>
);

export default DoneIcon;
